import type { ApolloError } from 'apollo-client';
import type { Action } from 'react-sweet-state';
import { createStateHook, createStore, createActionsHook } from 'react-sweet-state';

type FeatureUsageState = {
	featureUsageError?: ApolloError | Error;
	isUsingGuestAccess?: boolean;
	isUsingPageRestrictions?: boolean;
	numberOfUsers?: number;
	totalPageViews?: number;
};

const initialState: FeatureUsageState = {};

const actions = {
	setFeatureUsageError:
		(featureUsageError: ApolloError | Error): Action<FeatureUsageState> =>
		({ setState }) => {
			setState({ featureUsageError });
		},
	setIsUsingGuestAccess:
		(isUsingGuestAccess: boolean): Action<FeatureUsageState> =>
		({ setState }) => {
			setState({ isUsingGuestAccess });
		},
	setIsUsingPageRestrictions:
		(isUsingPageRestrictions: boolean): Action<FeatureUsageState> =>
		({ setState }) =>
			setState({ isUsingPageRestrictions }),
	setNumberOfUsers:
		(numberOfUsers?: number): Action<FeatureUsageState> =>
		({ setState }) => {
			setState({ numberOfUsers });
		},
	setTotalPageViews:
		(totalPageViews: number): Action<FeatureUsageState> =>
		({ setState }) => {
			setState({ totalPageViews });
		},
};

const Store = createStore<FeatureUsageState, typeof actions>({
	initialState,
	actions,
});

export const useFeatureUsageActions = createActionsHook(Store);
export const useFeatureUsage = createStateHook(Store);
